/* DON'T EDIT THIS FILE: edit original and run build again */ export const verifyTermsAndConditionsRequiredActionId =
  "acceptedTermsAndConditionsVersionNumber";

export const enforceVerifyTermsAndConditionsId =
  "enforceAcceptedTermsAndConditionsVerify";

export const verifyTermsAndConditionsRequiredActionTimeId =
  "acceptedTermsAndConditionsAtTime";
